export default __webpack_public_path__ + "static/media/XS4 3G Mifare (Mini, ONE, Mini Ansi).b3f79cf9.jpg";